import React from 'react';
import { Tooltip } from 'antd';
import { useIntl } from 'react-intl';
import { formatPercent, toPercentNumber } from 'utils/insights';
import './EfficiencyCellRenderer.scss';

type EfficiencyCellRendererProps = {
  value: number | undefined;
};

function pillModifier(percentValue: number): string {
  if (percentValue > 100) return 'efficiency-cell__pill--over';
  if (percentValue >= 80) return 'efficiency-cell__pill--high';
  if (percentValue >= 50) return 'efficiency-cell__pill--medium';
  return 'efficiency-cell__pill--low';
}

function EfficiencyCellRenderer({ value }: EfficiencyCellRendererProps) {
  const intl = useIntl();

  if (value === undefined || value === null || !Number.isFinite(value)) {
    return (
      <Tooltip
        title={intl.formatMessage({ id: 'efficiency.unavailable' })}
        placement="top">
        <span className="efficiency-cell__unavailable">—</span>
      </Tooltip>
    );
  }

  const percent = toPercentNumber(value);

  return (
    <Tooltip
      title={intl.formatMessage({ id: 'efficiency.tooltip' })}
      placement="top">
      <span className={['efficiency-cell__pill', pillModifier(percent)].join(' ')}>
        {formatPercent(value, 1)}
      </span>
    </Tooltip>
  );
}

export default EfficiencyCellRenderer;
